import { render, staticRenderFns } from "./ItemAuthorPlayer.vue?vue&type=template&id=36374cab"
import script from "./ItemAuthorPlayer.vue?vue&type=script&lang=ts"
export * from "./ItemAuthorPlayer.vue?vue&type=script&lang=ts"
import style0 from "./ItemAuthorPlayer.vue?vue&type=style&index=0&id=36374cab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports